import { userRoute } from './user';

export const allUserRoutes = [userRoute()];
